import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import MainLay from './pages/MainLay'
import auth from "./routers/auth";
import "./App.css";

import Home from "./pages/home2";
import Resource from "./pages/Resource";
import Genomes from "./pages/Genome/Genomes";
import GeneIndex from "./pages/Genome/GeneIndex";
import Pathway from "./pages/Genome/Pathway";
import Structure from "./pages/Populations/Structure";
import MutationInform from "./pages/Populations/MutationInform";
import Epigenome from "./pages/Epigenome";
import RanSeq from "./pages/Expression/Ransep";
import ExpressionAnalysis from "./pages/Expression/ExpressionAnalysis";

import SearchMetabolome from "./pages/Metabolome/SearchMetabolome";
import DefMetPages from './pages/Metabolome/Differential_metabolite'

import Download from "./pages/Download";
import Help from "./pages/Help/";
// import Helpv2 from "./pages/Helpv2/";


import Jbrowse from "./pages/Toolsv3/Jbrowse";
import Blast from "./pages/Toolsv3/Blast";
import GoKegg from "./pages/Toolsv3/GoKegg";
import DoMain from "./pages/Toolsv3/Domain";
import HeatMapPage from "./pages/Toolsv3/Heatmap";
import TF from "./pages/Toolsv3/TF";
import Design from "./pages/Toolsv3/Design";


const Login = lazy(() => import("./pages/login"));
const Obtain=lazy(()=>import('./pages/Obtain'))
//未登录无法访问的页面

const AutHGeneIndex=auth(GeneIndex);
const AuthStructure=auth(Structure);
const AuthMutationInform=auth(MutationInform);
const AuthRanSeq=auth(RanSeq);
const AuthExpressionAnalysis=auth(ExpressionAnalysis);
const AuthSearchMetabolome=auth(SearchMetabolome);
const AuthEpigenome=auth(Epigenome);
const AuthJbrowse=auth(Jbrowse);
const AuthBlast=auth(Blast);
const AuthGoKegg=auth(GoKegg);
const AuthDoMain=auth(DoMain);
const AuthHeatMapPage=auth(HeatMapPage);
const AuthTF=auth(TF);
const AuthDesign=auth(Design);

// const AuthMainLay = auth(MainLay);
function App() {
  return (
    <Suspense fallback={<div>加载中...</div>}>
      <Routes>
        <Route path="/lotus" element={<MainLay />}>
          <Route path="*" element={<div>暂未开发</div>} />
          <Route path="home" element={<Home />} />
          <Route path="resource" element={<Resource />} />
          <Route path="genomes" element={<Genomes />} />
          <Route path="geneindex" element={<GeneIndex />} />
          <Route path="pathway" element={<Pathway />} />
          <Route path="structure" element={<Structure />} />
          <Route path="mutationinform" element={<MutationInform />} />
          <Route path="epigenome" element={<Epigenome />} />
          <Route path="ranseq" element={<RanSeq />} />
          <Route path="expressionanalysis" element={<ExpressionAnalysis />} />
     
          <Route path="searchmetabolome" element={<SearchMetabolome/>}/>
          <Route path="defmet" element={<DefMetPages/>}/>
          <Route path="jbrowse" element={<Jbrowse />} />
          <Route path="blast" element={<Blast />} />
          <Route path="gokegg" element={<GoKegg />} />
          <Route path="domain" element={<DoMain />} />
          <Route path="heatmap" element={<HeatMapPage />} />
          <Route path="download" element={<Download />} />
         <Route path="help" element={<Help />} />
         {/* <Route path="help" element={<Helpv2 />} /> */}
          <Route path="tf" element={<TF />} />
          <Route path="design" element={<Design />} />
        </Route>

        <Route path="login" element={<Login />} />
        <Route path="obtain" element={<Obtain/>}/>
        <Route path="/404" element={<div>404</div>} />
        <Route path="/403" element={<div>403用户无权限</div>} />
        <Route path="*" element={<Navigate to="/404" />} />
        <Route path="/" element={<Navigate to="/lotus/home/" />} />
      </Routes>
    </Suspense>
  );
}

export default App;
// 1. 配置axios  基础配置
// 2. 配置  redux 基础配置
// 3. 配置路由   基础配置
// 4. 配置代理，配置后包括axios请求都不用再写域名了
// 5. 路由懒加载
// 6. 配置MainLay文件
// /lotus/home/
// /lotus/product/product_list
// /lotus/product/product_classify
// /lotus/cms/article/index
// /lotus/product/add_product
